<template>
  <div class="general-wrapper">
    <!-- <Header /> -->
    <div class="header">
      <h2 class="qrw-heading-xl">{{ $t("stats.title") }}</h2>
    </div>
    <div class="stat-head" v-if="busy">
      <h2 class="c-black">{{ $t("stats.loading") }}</h2>
    </div>
    <div class="px-50">
      <div class="stats-wrapper" v-if="!busy && hasCafeWorkedEnough">
        <div class="space-top">
          <h3 class="c-black">{{ $t("stats.general") }}</h3>

          <GeneralInfo
            :values="monthly.total"
            :previous="monthly_previous.total"
          />

          <StatsBarChart
            :showClientsTab="true"
            @changeTab="(tab) => (currentTabs.general = tab)"
            @changeRange="onGeneralChangeRange"
            :currentTab="currentTabs.general"
          />
          <div class="chart-wrapper">
            <GeneralGraph
              :inside="stats.inside.dataset"
              :preorder="stats.preorder.dataset"
              :delivery="stats.delivery.dataset"
              v-if="currentTabs.general == 'income'"
            />
            <StackGraph
              :inside="stats.inside.dataset"
              :preorder="stats.preorder.dataset"
              :delivery="stats.delivery.dataset"
              v-if="currentTabs.general == 'clients'"
            />

            <CompareGraph
              v-if="currentTabs.general == 'activity'"
              :inside="stats.inside.dataset"
              :preorder="stats.preorder.dataset"
              :delivery="stats.delivery.dataset"
            />

            <IncomeStatsPanel
              :stats="general_summary"
              v-if="currentTabs.general === 'income'"
            />
            <ActivityStatsPanel
              :summary="general_summary"
              :modes="{ delivery: true, inside: true, preorder: true }"
              v-if="currentTabs.general == 'activity'"
            />
            <ClientStatsPanel
              :values="general_summary"
              v-if="currentTabs.general == 'clients'"
            />
          </div>
        </div>

        <div class="space-top row">
          <RatioSystems :counts="systems_total" class="right-space" v-if="
            !systems_total.rooms
          "/>
          <!-- <PopularDishes :list="top_dishes" /> -->
          <TopStatsList
            :waiters="top_waiters"
            :clients="top_clients"
            :dishes="top_dishes"
          />
        </div>

        <div class="space-top" v-if="cafe.modes.delivery">
          <h3 class="c-black">DELIVERY</h3>
          <GeneralInfo
            :values="monthly.delivery"
            :previous="monthly_previous.delivery"
          />
          <StatsBarChart
            @changeTab="(tab) => (currentTabs.delivery = tab)"
            @changeRange="(r) => onRangeChange('delivery', r)"
            :currentTab="currentTabs.delivery"
            ref="deliveryBarChart"
          />
          <div class="chart-wrapper">
            <BasicGraph
              :dataset="stats.delivery.dataset"
              v-if="currentTabs.delivery == 'income'"
            />
            <VisitsGraph
              v-if="currentTabs.delivery == 'activity'"
              :color="deliveryGraphColors.main"
              :dataset="stats.delivery.dataset"
            />
            <IncomeStatsPanel
              :stats="stats.delivery.summary"
              :modes="{ delivery: true }"
              v-if="currentTabs.delivery == 'income'"
            />
            <ActivityStatsPanel
              :summary="stats.delivery.summary"
              :modes="{ delivery: true }"
              v-if="currentTabs.delivery == 'activity'"
            />
          </div>
        </div>

        <div class="space-top" v-if="cafe.modes.preorder">
          <h3 class="c-black">TAKEAWAY</h3>
          <GeneralInfo
            :values="monthly.preorder"
            :previous="monthly_previous.preorder"
          />
          <StatsBarChart
            @changeTab="(tab) => (currentTabs.preorder = tab)"
            @changeRange="(r) => onRangeChange('preorder', r)"
            :currentTab="currentTabs.preorder"
            ref="preorderBarChart"
          />
          <div class="chart-wrapper">
            <BasicGraph
              :dataset="stats.preorder.dataset"
              :color="preorderGraphColors.main"
              v-if="currentTabs.preorder == 'income'"
            />

            <VisitsGraph
              v-if="currentTabs.preorder == 'activity'"
              :color="preorderGraphColors.main"
              :dataset="stats.preorder.dataset"
            />
            <IncomeStatsPanel
              :stats="stats.preorder.summary"
              :modes="{ preorder: true }"
              v-if="currentTabs.preorder == 'income'"
            />
            <ActivityStatsPanel
              :summary="stats.preorder.summary"
              :modes="{ preorder: true }"
              v-if="currentTabs.preorder == 'activity'"
            />
          </div>
        </div>

        <div class="space-top" v-if="cafe.modes.inside">
          <h3 class="c-black">INSIDE</h3>
          <GeneralInfo
            :values="monthly.inside"
            :previous="monthly_previous.inside"
          />
          <StatsBarChart
            @changeTab="(tab) => (currentTabs.inside = tab)"
            @changeRange="(r) => onRangeChange('inside', r)"
            :currentTab="currentTabs.inside"
            ref="insideBarChart"
          />
          <div class="chart-wrapper">
            <BasicGraph
              :dataset="stats.inside.dataset"
              :color="insideGraphColors.main"
              v-if="currentTabs.inside == 'income'"
            />

            <VisitsGraph
              v-if="currentTabs.inside == 'activity'"
              :color="insideGraphColors.main"
              :dataset="stats.inside.dataset"
            />
            <IncomeStatsPanel
              :stats="stats.inside.summary"
              :modes="{ inside: true }"
              v-if="currentTabs.inside == 'income'"
            />
            <ActivityStatsPanel
              :summary="stats.inside.summary"
              :modes="{ inside: true }"
              v-if="currentTabs.inside == 'activity'"
            />
          </div>
        </div>

        <div class="space-top" v-if="cafe.modes.hotels">
          <h3 class="c-black">ROOMS</h3>
          <GeneralInfo
            :values="monthly.rooms"
            :previous="monthly_previous.rooms"
          />
          <StatsBarChart
            @changeTab="(tab) => (currentTabs.rooms = tab)"
            @changeRange="(r) => onRangeChange('rooms', r)"
            :currentTab="currentTabs.rooms"
            ref="preorderBarChart"
          />
          <div class="chart-wrapper">
            <BasicGraph
              :dataset="stats.rooms.dataset"
              :color="roomsGraphColors.main"
              v-if="currentTabs.rooms == 'income'"
            />

            <VisitsGraph
              v-if="currentTabs.rooms == 'activity'"
              :color="preorderGraphColors.main"
              :dataset="stats.rooms.dataset"
            />
            <IncomeStatsPanel
              :stats="stats.rooms.summary"
              :modes="{ rooms: true }"
              v-if="currentTabs.rooms == 'income'"
            />
            <ActivityStatsPanel
              :summary="stats.preorder.summary"
              :modes="{ rooms: true }"
              v-if="currentTabs.rooms == 'activity'"
            />
          </div>
        </div>
        <!-- <ClientsTable :clients="clients" @imported="onClientsImported" /> -->
      </div>
      <div class="stats-wrapper" v-else-if="!busy && !hasCafeWorkedEnough">
        <IQOS :hideTitle="false" class="iqos-empty">
          <p class="comment pt-0 c-white">
            {{ $t("stats.empty_desc") }}
          </p>
        </IQOS>
      </div>
    </div>
    <RemoteScroller v-if="!busy" />
  </div>
</template>

<script>
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.defaults.global.plugins.datalabels.anchor = "end";
Chart.defaults.global.plugins.datalabels.align = "end";
Chart.plugins.unregister(ChartDataLabels);

import GeneralInfo from "@/components/stats/GeneralInfo.vue";
import StatsBarChart from "@/components/stats/StatsBarChart.vue";
import IncomeStatsPanel from "@/components/stats/IncomeStatsPanel.vue";
import ClientStatsPanel from "@/components/stats/ClientStatsPanel.vue";
import GeneralGraph from "@/components/stats/GeneralGraph.vue";
import BasicGraph from "@/components/stats/BasicGraph.vue";
import CompareGraph from "@/components/stats/CompareGraph.vue";
import StackGraph from "@/components/stats/StackGraph.vue";
import RatioSystems from "@/components/stats/RatioSystems.vue";
import PopularDishes from "@/components/stats/PopularDishes.vue";
import VisitsGraph from "@/components/stats/VisitsGraph.vue";

import TopStatsList from "@/components/stats/TopStatsList.vue";

import IQOS from "@/components/IQOS.vue";

import ActivityStatsPanel from "@/components/stats/ActivityStatsPanel.vue";

import ClientsTable from "@/components/stats/ClientsTable.vue";

import StatsAPI from "@/api/stats";

import RemoteScroller from "@/components/RemoteScroller.vue";

import moment from "moment";

export default {
  data() {
    return {
      busy: true,

      top_waiters: [],
      top_clients: [],
      top_dishes: [],

      stats: {
        inside: {},
        preorder: {},
        delivery: {},
        rooms: {},
      },
      general_summary: null,
      top_dishes: [],
      top_clients: [],
      top_waiters: [],
      monthly: [],
      monthly_previous: [],
      clients: [],
      comparisons: {},

      currentTabs: {
        general: "income",
        inside: "income",
        preorder: "income",
        delivery: "income",
        rooms: "income",
      },

      systems_total: {},

      deliveryGraphColors: {
        main: "#CBD9E6",
        extra: "#464646",
      },
      insideGraphColors: {
        main: "#129B81",
        extra: "#464646",
      },
      preorderGraphColors: {
        main: "#FFD2A8",
        extra: "#464646",
      },
      roomsGraphColors: {
        main: "#129B81",
        extra: "#464646",
      },
    };
  },
  methods: {
    fetchTops() {
      Promise.all([
        StatsAPI.getTopWaiters(this.cafesForStats[0]._id),
        StatsAPI.getTopClients(this.cafesForStats[0]._id),
        StatsAPI.getTopDishes(this.cafesForStats[0]._id),
      ])
        .then((results) => {
          this.top_waiters = results[0].top_waiters;
          this.top_clients = results[1].top_clients;
          this.top_dishes = results[2].top_dishes.map((p) => p.name);
        })
        .catch((error) => {});
    },
    fetchData() {
      if (!this.hasCafeWorkedEnough) {
        this.busy = false;
        return;
      }

      const start = moment().subtract(7, "days").startOf("day").valueOf();
      const end = moment().endOf("day").valueOf();

      const range = {
        start,
        end,
      };

      this.stats.preorder.range = range;
      this.stats.delivery.range = range;
      this.stats.inside.range = range;

      Promise.all([
        StatsAPI.getForMode(this.cafe._id, "inside", start, end),
        StatsAPI.getForMode(this.cafe._id, "preorder", start, end),
        StatsAPI.getForMode(this.cafe._id, "delivery", start, end),
        StatsAPI.getMonthly(this.cafe._id, false),
        StatsAPI.getTopDishes(),
        StatsAPI.getClients(this.cafe._id),
        StatsAPI.getMonthly(this.cafe._id, true),
        StatsAPI.getTopWaiters(this.cafe._id),
        StatsAPI.getTopClients(this.cafe._id),
        StatsAPI.getForMode(this.cafe._id, "rooms", start, end),
      ])
        .then((results) => {
          const inside_response = results[0];
          const preorder_response = results[1];
          const delivery_response = results[2];

          const monthly_response = results[3];
          const top_dishes_response = results[4];

          const clients_response = results[5];

          this.stats.inside = inside_response.stats;
          this.stats.preorder = preorder_response.stats;
          this.stats.delivery = delivery_response.stats;

          // this.stats.inside.visits = inside_visits.visits;
          // this.stats.preorder.visits = preorder_visits.visits;
          // this.stats.delivery.visits = delivery_visits.visits;

          this.monthly = monthly_response.monthly;
          this.top_dishes = top_dishes_response.top_dishes;

          // this.clients = clients_response.clients;

          this.monthly_previous = results[6].monthly;

          this.top_waiters = results[7].top_waiters;
          this.top_clients = results[8].top_clients;

          this.stats.rooms = results[9].stats;

          this.buildDatasets();
          this.busy = false;
        })
        .catch((error) => {
          console.error(error);
          this.$store.dispatch("showError", "stats_failed");
        });
    },
    buildDatasets() {
      //Ratio Systems
      this.systems_total = {
        // inside: this.monthly.inside.orders,
        // preorder: this.monthly.preorder.orders,
        // delivery: this.monthly.delivery.orders,
      };

      Object.entries(this.monthly).forEach((entry) => {
        const key = entry[0];
        const _stats = entry[1];

        if (key == 'total') return;

        if (!this.general_summary) {
          this.general_summary = Object.assign({}, _stats);
        } else {
          this.general_summary.orders += _stats.orders;
          this.general_summary.income += _stats.income;
          this.general_summary.visits += _stats.visits;
          this.general_summary.bounce += _stats.bounce;
        }

        this.$set(this.systems_total, key, _stats.orders);

        this.systems_total[key] = _stats.orders;
      });

      this.general_summary.average = Math.round(
        this.general_summary.income / this.general_summary.orders
      );

      this.general_summary.bounce = Math.round(
        this.general_summary.bounce / Object.keys(this.monthly).length
      );

      const total_new_clients = this.stats.inside.dataset.reduce(
        (acc, item, index) => {
          return acc + this.stats.inside
            ? this.stats.inside.dataset[index].new_clients
            : 0 + this.stats.preorder
            ? this.stats.preorder.dataset[index].new_clients
            : 0 + this.stats.delivery
            ? this.stats.delivery.dataset[index].new_clients
            : 0;
        },
        0
      );

      const total_returning_clients = this.stats.inside.dataset.reduce(
        (acc, item, index) => {
          return acc + this.stats.inside
            ? this.stats.inside.dataset[index].returning_clients
            : 0 + this.stats.preorder
            ? this.stats.preorder.dataset[index].returning_clients
            : 0 + this.stats.delivery
            ? this.stats.delivery.dataset[index].returning_clients
            : 0;
        },
        0
      );

      // const returning_data = this.stats.inside.dataset.map((item, index) => {
      //   return this.stats.inside.dataset[index].returning_clients
      //     + this.stats.preorder.dataset[index].returning_clients
      //     + this.stats.delivery.dataset[index].returning_clients;
      // });

      this.general_summary.new_clients = total_new_clients;
      this.general_summary.returning_clients = total_returning_clients;
    },
    onGeneralChangeRange(new_range) {
      const range = this.parseStringRange(new_range);
      const start = range.start;
      const end = range.end;
      Promise.all([
        StatsAPI.getForMode(this.cafe._id, "inside", start, end),
        StatsAPI.getForMode(this.cafe._id, "preorder", start, end),
        StatsAPI.getForMode(this.cafe._id, "delivery", start, end),
      ])
        .then((results) => {
          this.stats.inside = results[0].stats;
          this.stats.preorder = results[1].stats;
          this.stats.delivery = results[2].stats;

          if (this.$refs.preorderBarChart)
            this.$refs.preorderBarChart.setUiRange(new_range);
          if (this.$refs.deliveryBarChart)
            this.$refs.deliveryBarChart.setUiRange(new_range);

          this.buildDatasets();
        })
        .catch((error) => {
          this.$store.dispatch("showError", "stats_failed");
          console.error(error);
        });
    },
    parseStringRange(new_range) {
      let range = {
        start: null,
        end: null,
      };

      if (new_range == "week") {
        range.start = moment().subtract(7, "days").valueOf();
        range.end = moment().endOf("day").valueOf();
      } else if (new_range == "two_weeks") {
        range.start = moment().subtract(14, "days").startOf("day").valueOf();
        range.end = moment().endOf("day").valueOf();
      } else if (new_range == "month") {
        range.start = moment().subtract(30, "days").valueOf();
        range.end = moment().endOf("day").valueOf();
      }

      return Object.assign({}, range);
    },
    onRangeChange(mode, new_range) {
      const range = this.parseStringRange(new_range);

      this.$set(this.stats[mode], "range", range);

      StatsAPI.getForMode(this.cafe._id, mode, range.start, range.end)
        .then((data) => {
          this.stats[mode] = data.stats;
          this.$nextTick(this.buildDatasets);
        })
        .catch((error) => {
          this.$store.dispatch("showError", "stats_failed");
          console.error(error);
        });
    },
    onClientsImported() {
      StatsAPI.getClients()
        .then((data) => {
          this.clients = data.clients;
        })
        .catch((error) => {
          this.$store.dispatch("showError", "stats_failed");
        });
    },
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    hasCafeWorkedEnough() {
      return true;
      // return moment().diff(moment(this.cafe.registered), "days") >= 7;
    },
  },
  components: {
    GeneralInfo,
    GeneralGraph,
    BasicGraph,
    RatioSystems,
    CompareGraph,
    StackGraph,
    PopularDishes,
    StatsBarChart,
    IncomeStatsPanel,
    ClientStatsPanel,
    VisitsGraph,
    ActivityStatsPanel,
    ClientsTable,
    TopStatsList,
    RemoteScroller,
    IQOS,
  },
};
</script>

<style scoped>
.stats-wrapper {
  width: 117.1vh;
}

.w-inherit {
  width: inherit;
}

.chart-wrapper {
  width: auto;
  display: flex;
}

.mt-3 {
  margin-top: 2.2vh !important;
}

.mr-3 {
  margin-right: 2.2vh !important;
}

.spacer-top {
  padding-top: 9.3vh;
}

.stat-head h2 {
  font-size: 4vh;
  padding-left: 5.5vh;
}

h3,
h4,
h5,
p {
  margin-bottom: 0;
}

h5 {
  font-size: 2vh;
}

p {
  font-size: 1.7vh;
}

h4,
h3 span {
  font-size: 1.8vh;
}

.pie-info p {
  padding: 1vh 0;
}

h3 {
  font-size: 2.8vh;
  color: #ededed;
}

.stats-info:first-child {
  padding-left: 0;
}
.stats-info:last-child {
  border-right: 0;
  padding-right: 0;
}

.stats-info {
  display: flex;
  flex-flow: column;
  border-right: 1px solid #c4c4c4;
  padding: 0 6vh;
}

.stats-info img {
  height: 1.5vh;
  width: 1.5vh;
}
</style>
